import { render, staticRenderFns } from "./ExpenditureApprove.vue?vue&type=template&id=ccab5320&scoped=true"
import script from "./ExpenditureApprove.vue?vue&type=script&lang=js"
export * from "./ExpenditureApprove.vue?vue&type=script&lang=js"
import style0 from "./ExpenditureApprove.vue?vue&type=style&index=0&id=ccab5320&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccab5320",
  null
  
)

export default component.exports